import { getTranslatedText } from '@nile/components';
import { DisabledTag } from '@nile/mangifera/src/Pebbles/TicketContainer';
import React from 'react';
import { injectIntl } from 'react-intl';
import styled from 'styled-components';

const SubjectCellWrapper = styled.div`
  max-width: 100%;
  text-transform: lowercase !important;
`;

const frequenciesMap = {
  MONTHLY: 'admin.timeScheduler.frequency.monthly',
  WEEKLY: 'admin.timeScheduler.frequency.weekly',
  HOURLY: 'admin.timeScheduler.frequency.hourly',
  DAILY: 'admin.timeScheduler.frequency.daily'
};

const frequencyMap = {
  MONTHLY: 'admin.timeScheduler.frequency.monthlyOnce',
  WEEKLY: 'admin.timeScheduler.frequency.weeklyOnce',
  HOURLY: 'admin.timeScheduler.frequency.hourlyOnce',
  DAILY: 'admin.timeScheduler.frequency.dailyOnce'
};

function ScheduleFrequencyCell(props) {
  const { cell, intl } = props;
  const value = JSON.parse(cell.value);

  function getDisplayFrequncy(val) {
    switch (val.frequency) {
      case 'ONCE':
        return getTranslatedText(
          intl,
          'admin.timeScheduler.frequency.onlyOnce'
        );
      default:
        return `${getTranslatedText(intl, 'admin.timeScheduler.prefix.once')}
        ${val?.data?.repeatInterval} ${getTranslatedText(
          intl,
          // val?.data?.repeatInterval === 1 ?
          frequencyMap[val.frequency]
          // : frequenciesMap[val.frequency]
        )}`;
    }
  }
  const displayValue = getDisplayFrequncy(value);
  return value ? (
    <SubjectCellWrapper
      className="full-width ellipsis"
      id={value}
      title={displayValue}
    >
      {displayValue}
    </SubjectCellWrapper>
  ) : (
    <DisabledTag>NA</DisabledTag>
  );
}

export default injectIntl(ScheduleFrequencyCell);
